/**
 * POD Selector Component
 *
 * Custom dropdown for selecting related POD products.
 */

class PodSelector extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.pod-selector__toggle');
    this.menu = this.querySelector('.pod-selector__menu');

    if (this.toggle && this.menu) {
      this.toggle.addEventListener('click', this.handleToggleClick.bind(this));
      document.addEventListener('click', this.handleOutsideClick.bind(this));
      this.addEventListener('keydown', this.handleKeydown.bind(this));
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this));
  }

  handleToggleClick(e) {
    e.preventDefault();
    this.toggleMenu();
  }

  toggleMenu() {
    const isOpen = this.classList.toggle('is-open');
    this.toggle.setAttribute('aria-expanded', isOpen);
    this.updateParentZIndex(isOpen);

    if (isOpen) {
      // Focus selected item or first item
      const selected = this.menu.querySelector('.pod-selector__item--selected');
      const firstItem = this.menu.querySelector('.pod-selector__item');
      (selected || firstItem)?.focus();
    }
  }

  closeMenu() {
    this.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.updateParentZIndex(false);
  }

  updateParentZIndex(isOpen) {
    const section = this.closest('[id^="shopify-section"]');
    if (section) {
      section.style.zIndex = isOpen ? '999' : '';
      section.style.position = isOpen ? 'relative' : '';
    }
  }

  handleOutsideClick(e) {
    if (!this.contains(e.target)) {
      this.closeMenu();
    }
  }

  handleKeydown(e) {
    if (e.key === 'Escape') {
      this.closeMenu();
      this.toggle.focus();
    }

    // Arrow key navigation
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      const items = [...this.menu.querySelectorAll('.pod-selector__item')];
      const currentIndex = items.indexOf(document.activeElement);

      let nextIndex;
      if (e.key === 'ArrowDown') {
        nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
      } else {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
      }

      items[nextIndex]?.focus();
    }
  }
}

customElements.define('pod-selector', PodSelector);
